import React from "react";

import marketingImg from "../../assets/images/services-marketing.jpg";
import salesImg from "../../assets/images/services-sales.jpg";
import supportImg from "../../assets/images/services-support.jpg";
import administrationImg from "../../assets/images/services-administration.png";
import smartmonitoringImg from "../../assets/images/services-smartmonitoring.jpg";
import HeroSection from "./components/HeroSection/HeroSection";
import NewHeroSection from "./components/HeroSection/NewHeroSection";
import NewHeroSection2 from "./components/HeroSection/NewHeroSection2";
import NewHeroSection3 from "./components/HeroSection/NewHeroSection3";

const Card = ({ image, heading, description }) => (
  <div className="bg-white shadow-md rounded-lg overflow-hidden w-60">
    <img src={image} alt={heading} className="w-full h-48 object-cover" />
    <div className="p-4">
      <h2 className="text-xl font-bold">{heading}</h2>
      <p className="mt-2 text-gray-600">{description}</p>
    </div>
  </div>
);

const ServicesPage = () => {
  const services = [
    {
      image: marketingImg,
      heading: "Marketing AI Agent",
      description:
        "Lead Capture, Audience Targeting, Personalized Outreach, Multi Channel Campaigns",
    },
    {
      image: salesImg,
      heading: "Sales AI Agent",
      description:
        "Automated Follow-ups, Booking Appointments, Lead Management & Qualification, Post purchase Customer Experience, Lead generation and Personalized Outreach",
    },
    {
      image: supportImg,
      heading: "Support AI Agent",
      description:
        "24/7 Support Availability, Knowledge Base Assistance, Quick Resolution, Automated Ticketing and routing, Personalized suggestions, Multilingual Support",
    },
    {
      image: administrationImg,
      heading: "Administrative & Workflow Automation",
      description:
        "Appointment Scheduling, Task Assignment & Tracking, Automated Billing & Invoicing, Automated Data Entry & Reporting",
    },
    {
      image: smartmonitoringImg,
      heading: "Smart Monitoring & Alerts",
      description:
        "Safety Alerts, Business Insights, Equipment Monitoring, Supply Chain Monitoring, Customer Behavior Analytics",
    },
  ];

  return (
    <div>
      {/* <HeroSection /> */}
      <NewHeroSection />
      <NewHeroSection2/>
      <NewHeroSection3/>
      {/* <SelfHostedGPT/> */}
      {/* <div className="text-4xl bg-blue-400 text-white font-bold text-center p-8 my-4">
        What We Offer !
      </div>
      <div className="container mx-auto px-4 py-8 flex flex-wrap gap-8 justify-center">
        {services.map((service, index) => (
          <Card
            key={index}
            image={service.image}
            heading={service.heading}
            description={service.description}
          />
        ))}
      </div> */}
    </div>
  );
};

export default ServicesPage;
